// extracted by mini-css-extract-plugin
var _1 = "Container-TM0U2";
var _2 = "Highlighted-sjFFF";
var _3 = "Icon-toO1L";
var _4 = "Paragraph-DvERB";
var _5 = "SubTitle-Nbmc5";
var _6 = "Texts-K9Zjf";
var _7 = "Title-i33q_";
var _8 = "Titles-gaotq";
var _9 = "UspBlock-tPp4N";
export { _1 as "Container", _2 as "Highlighted", _3 as "Icon", _4 as "Paragraph", _5 as "SubTitle", _6 as "Texts", _7 as "Title", _8 as "Titles", _9 as "UspBlock" }
